// src/components/OptForm.tsx
import React, { FC, useState, useEffect } from 'react';
import OtpInput from './subComponents/OtpInput';

interface OptFormProps {
  onSubmit: (otp: string) => void;
  onResend: () => void;
}

const OptForm: FC<OptFormProps> = ({ onSubmit, onResend }) => {
  const [otp, setOtp] = useState('');
  const [timer, setTimer] = useState(60);

  // countdown
  useEffect(() => {
    if (timer <= 0) return;
    const id = setInterval(() => setTimer((t) => t - 1), 1000);
    return () => clearInterval(id);
  }, [timer]);

  const formatTime = (sec: number) => {
    const s = sec % 60;
    return `00:${s < 10 ? '0' : ''}${s}`;
  };

  return (
    <div className=''>
      <OtpInput value={otp} onChange={setOtp} />

      <p className='text-red-500 mt-2'>
        {timer > 0 ? `${formatTime(timer)} Left` : '—'}
      </p>

      <button
        onClick={() => onSubmit(otp)}
        className='w-full max-w-xs bg-[#FF0050] text-white py-2 rounded-full mt-6 hover:bg-pink-600 transition'
      >
        Submit Code
      </button>

      <div className='mt-4 text-sm'>
        <span>Didn't receive code? </span>
        <button
          disabled={timer > 0}
          onClick={() => {
            onResend();
            setOtp('');
            setTimer(60);
          }}
          className={`underline ${timer > 0 ? 'text-gray-400 cursor-not-allowed' : 'text-blue-600'}`}
        >
          Resend Code
        </button>
      </div>
    </div>
  );
};

export default OptForm;
